import * as types from "./types";

export const fetchCallLogs = (payload?: any) => ({
  type: types.FETCH_CALL_LOGS,
  payload,
});
export const fetchIvrMenus = (payload?: any) => ({
  type: types.FETCH_IVR_MENUS,
  payload,
});

export const syncIvrMenus = (payload?: any) => ({
  type: types.SYNC_IVR_MENUS,
  payload,
});

export const syncExtensions = (payload?: any) => ({
  type: types.SYNC_EXTENSIONS,
  payload,
});

export const customerInfo = (payload: any) => ({
  type: types.FETCH_CUSTOMER_INFO,
  payload,
});
export const fetchCallDetail = (sessionId: string) => ({
  type: types.FETCH_CALL_DETAIL,
  payload: sessionId,
});

export const updateCallLog = (sessionId: string, body: any) => ({
  type: types.UPDATE_CALL_LOG,
  payload: { sessionId, body },
});

export const queueCalls = (payload?: any) => ({
  type: types.FETCH_QUEUE_CALLS,
  payload,
});

export const fetchCallStats = () => ({
  type: types.FETCH_CALL_STATS,
});

export const fetchCallLogsDetails = (payload?: any) => ({
  type: types.FETCH_CALL_LOGS_DETAILS,
  payload,
});

export const fetchCallLogsGetExtension = () => ({
  type: types.FETCH_CALL_LOGS_GET_EXTENSIONS,
});
